import React from 'react';
import {useSelector} from "react-redux";
import {UnlimitedTable} from "../../../components";

function ChecklistTab({id}) {
    // Redux
    const order = useSelector(state =>
        state.orders
            ?.find(item => item.cartID == id)
            ?.qnA.filter(item => item.questionType === "checklist")
    );

    return (
        <div>
            {order?.map((qna, index) => (
                <UnlimitedTable
                    key={index}
                    question={qna.questionName}
                    answers={qna.answers}
                />
            ))}
        </div>
    );
}

export default ChecklistTab;